<p-toast position="top-center" />

<div class="flex h-screen w-full items-center justify-center bg-white">
  <div class="w-full max-w-md px-6 py-10">

    <!-- Logo -->
    <div class="mb-8 text-center">
      <img src="./assets/logos/energo_logo.svg" class="mx-auto w-40 dark:hidden" alt="Logo" />
      <img src="./assets/logos/energo_logo_dark.svg" class="mx-auto w-40 hidden dark:block" alt="Logo" />
    </div>

    <!-- Step indicator -->
    <div class="mb-8 flex items-center justify-center gap-2">
      @for(s of [1,2,3]; track s){
        <div class="h-2 rounded-full transition-all duration-300"
          [class]="step >= s ? 'w-10 bg-vivid-royal-500' : 'w-2 bg-gray/30'"></div>
      }
    </div>

    <!-- STEP 1: Client number -->
    @if(step === 1){
      <div class="text-center mb-6">
        <h1 class="text-xl font-semibold text-vivid-royal-500 dark:text-vivid-royal-200">Validación de cuenta</h1>
        <p class="mt-2 text-sm text-gray">Ingresa tu número de cliente para continuar</p>
      </div>

      <form (ngSubmit)="nextStep()" [formGroup]="recoveryForm">
        <div class="mb-5">
        <p-floatlabel variant="on">
          <div class="relative w-full">
            <i class="pi pi-user absolute left-3 top-1/2 -translate-y-1/2 text-gray/50 z-10 text-sm"></i>
            <p-inputnumber
              formControlName="clientNumber"
              inputId="clientNumber"
              [useGrouping]="false"
              [maxlength]="7"
              [min]="1"
              [max]="9999999"
              styleClass="w-full"
              inputStyleClass="w-full !pl-10" />
          </div>
          <label for="clientNumber">No. de cliente</label>
        </p-floatlabel>
      </div>

        <p-button label="Validar" type="submit" [disabled]="enProceso" styleClass="w-full" />
        <div class="mt-4 text-center">
          <button type="button" (click)="backStep()" class="text-sm text-medium_purple hover:underline">Regresar al login</button>
        </div>
      </form>
    }

    <!-- STEP 2: Phone verification -->
    @if(step === 2){
      <div class="text-center mb-6">
        <h1 class="text-xl font-semibold text-vivid-royal-500 dark:text-vivid-royal-200">Verificación de teléfono</h1>
      </div>

      <div class="mb-5 rounded-lg bg-vivid-royal-50 p-4 text-sm text-vivid-royal-800 dark:text-vivid-royal-100">
        <p>Confirma el número de teléfono registrado: <b>{{hiddenPhone}}</b></p>
        <p class="mt-2 text-xs text-gray">Si no reconoces el número, contacta a atención al cliente.</p>
      </div>

      <form (ngSubmit)="nextStep()" [formGroup]="recoveryForm">
        <div class="mb-5">
        <div class="flex gap-2">
          <select [(ngModel)]="selectedLada" [ngModelOptions]="{standalone: true}" class="w-28 rounded-md border border-gray-300 dark:border-vivid-royal-700 dark:bg-crayola-blue-800 dark:text-white px-2 py-2 text-sm">
            @for(opt of ladaOptions; track opt.value) {
              <option [value]="opt.value">{{opt.label}}</option>
            }
          </select>
          <p-floatlabel variant="on" class="flex-1">
            <input pInputText formControlName="phoneNumber" id="phoneNumber" class="w-full" maxlength="10" inputmode="numeric" appOnlyNumbers />
            <label for="phoneNumber">No. de teléfono</label>
          </p-floatlabel>
        </div>
      </div>

      <p class="mb-5 text-xs text-gray italic">
        Si el teléfono coincide, recibirás un código por WhatsApp al presionar <b>Validar teléfono</b>.
      </p>

        <p-button label="Validar teléfono" type="submit" [disabled]="enProceso || phoneNumber.invalid" styleClass="w-full" />
        <div class="mt-4 text-center">
          <button type="button" (click)="backStep()" [disabled]="enProceso" class="text-sm text-medium_purple hover:underline">Regresar</button>
        </div>
      </form>
    }

    <!-- STEP 3: New password -->
    @if(step === 3){
      <div class="text-center mb-6">
        <h1 class="text-xl font-semibold text-vivid-royal-500 dark:text-vivid-royal-200">Nueva contraseña</h1>
        <p class="mt-2 text-sm text-gray">Crea una contraseña segura para tu cuenta</p>
      </div>

      <div [formGroup]="passwordForm">
        <div class="mb-4">
          <p-floatlabel variant="on">
            <div class="relative w-full">
              <i class="pi pi-lock absolute left-3 top-1/2 -translate-y-1/2 text-gray/50 z-10 text-sm"></i>
              <p-password
                formControlName="newPassword"
                inputId="newPassword"
                [toggleMask]="true"
                [feedback]="false"
                styleClass="w-full"
                inputStyleClass="w-full !pl-10" />
            </div>
            <label for="newPassword">Nueva contraseña</label>
          </p-floatlabel>
        </div>

        <div class="mb-4">
          <p-floatlabel variant="on">
            <div class="relative w-full">
              <i class="pi pi-lock absolute left-3 top-1/2 -translate-y-1/2 text-gray/50 z-10 text-sm"></i>
              <p-password
                formControlName="confirmPassword"
                inputId="confirmPassword"
                [toggleMask]="true"
                [feedback]="false"
                styleClass="w-full"
                inputStyleClass="w-full !pl-10" />
            </div>
            <label for="confirmPassword">Confirmar contraseña</label>
          </p-floatlabel>
        </div>

        <!-- Password rules -->
        <div class="mb-5 rounded-lg bg-vivid-royal-50 dark:bg-vivid-royal-900 p-3 text-xs space-y-1">
          <span class="block" [ngClass]="passwordFormField!.value?.match('.{12,}') ? 'text-green-600' : 'text-vivid-royal-400'">
            <i class="pi" [ngClass]="passwordFormField!.value?.match('.{12,}') ? 'pi-check-circle text-green-500' : 'pi-circle text-gray-300'"></i>
            12+ caracteres
          </span>
          <span class="block" [ngClass]="passwordFormField!.value?.match('(?=.*[A-Z])') ? 'text-green-600' : 'text-vivid-royal-400'">
            <i class="pi" [ngClass]="passwordFormField!.value?.match('(?=.*[A-Z])') ? 'pi-check-circle text-green-500' : 'pi-circle text-gray-300'"></i>
            Mayúscula
          </span>
          <span class="block" [ngClass]="passwordFormField!.value?.match('(?=.*[a-z])') ? 'text-green-600' : 'text-vivid-royal-400'">
            <i class="pi" [ngClass]="passwordFormField!.value?.match('(?=.*[a-z])') ? 'pi-check-circle text-green-500' : 'pi-circle text-gray-300'"></i>
            Minúscula
          </span>
          <span class="block" [ngClass]="passwordFormField!.value?.match('(?=.*[0-9])') ? 'text-green-600' : 'text-vivid-royal-400'">
            <i class="pi" [ngClass]="passwordFormField!.value?.match('(?=.*[0-9])') ? 'pi-check-circle text-green-500' : 'pi-circle text-gray-300'"></i>
            Número
          </span>
          <span class="block" [ngClass]="passwordFormField!.value?.match('(?=.*[!@#$%^&*()_+\\-=\\[\\]{}|;:,.<>?/])') ? 'text-green-600' : 'text-vivid-royal-400'">
            <i class="pi" [ngClass]="passwordFormField!.value?.match('(?=.*[!@#$%^&*()_+\\-=\\[\\]{}|;:,.<>?/])') ? 'pi-check-circle text-green-500' : 'pi-circle text-gray-300'"></i>
            {{'Carácter especial (!@#$%^&*)'}}
          </span>
          @if(passwordFormField!.value && confirmPasswordFormField!.value && passwordFormField!.value !== confirmPasswordFormField!.value){
            <span class="block text-red-500">
              <i class="pi pi-times-circle"></i> Las contraseñas no coinciden
            </span>
          }
        </div>
      </div>

      <p-button label="Guardar" type="submit" (onClick)="saveNewPassword()"
        [disabled]="enProceso || passwordForm.invalid || passwordFormField!.value !== confirmPasswordFormField!.value"
        styleClass="w-full" />
    }

  </div>
</div>

<!-- 2FA Modal -->
@if(show2FA){
  <app-auth-code-form-user
    [phoneNumber]="this.phoneNumber.value"
    [email]="''"
    [clientNumber]="clientNumber.value"
    [dialcode]="'52'"
    (closeModal)="this.show2FA=false;"
    [IsPhone]="true"
    (validate)="validateOTP($event)"
    [isRecovery]="true">
  </app-auth-code-form-user>
}



@if(enProceso){
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
    <app-loader [message]="'Procesando'"></app-loader>
  </div>
}
